import { notificationOptions } from './constants';
import { Close, CloseWrapper, ContentWrapper, IconWrapper, NotificationsWrapper, Text, Title } from './styled';
import { NotificationType } from './types';

type Props = {
  type: NotificationType;
  title?: string;
  description: string;
  onClose?: () => void;
};

const Notification = ({ type, title, description, onClose }: Props): JSX.Element => {
  return (
    <NotificationsWrapper
      data-testid="notificationWrapper"
      className="notificationWrapper"
      $backgroundColor={notificationOptions[type].backgroundColor}
      $backgroundBorderColor={notificationOptions[type].backgroundBorderColor}
      $color={notificationOptions[type].contentColor}
    >
      <ContentWrapper>
        <IconWrapper data-test="notificationIconWrapper" $color={notificationOptions[type].contentColor}>
          {' '}
          {notificationOptions[type].icon}
        </IconWrapper>
        <Title data-testid="notificationTitle" type={type}>
          {title || notificationOptions[type].defaultTitle}
        </Title>
        <Text data-testid="notificationDescription">{description}</Text>
      </ContentWrapper>
      {onClose && (
        <CloseWrapper data-testid="closeNotificationWrapper">
          <Close data-testid="closeNotification" $color={notificationOptions[type].contentColor} onClick={onClose} />
        </CloseWrapper>
      )}
    </NotificationsWrapper>
  );
};

export default Notification;
